import React from 'react';

const FormEttDropdownItems = ({ettEventList}) => {
  return ettEventList.map(item => (
    <option
      key={item.id}
      value={item.id}
    >
      {item.eventName}
    </option>
  ));
};

export default FormEttDropdownItems;
